export enum CheckInTypes {
    RemoteKiosk = 1,
    Mobile = 2,
    PublicPortal = 3,
    DriverPortal = 4,
}
